import { BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  empretec_actor_without_interview,
  empretec_candidate_text_without_interview,
  empretec_graphics_withtou_interview,
} from '../../../../utils/images';
import {
  BackgroundCandidate,
  CandidateInterviewWrapper,
  ContentWithOutInterviewWrapper,
  ImageEmpretecText,
} from '../../pages/candidate-interview/candidate-interview-styled';
import Button from '../button';
import { LayoutCandidate } from '../layout-candidate';

export const CandidateWithoutInterview = () => {
  const { tokenInfo } = Sebrae.useAuth();

  const pageSettings = React.useMemo(() => {
    return {
      empretecCandidateActor: empretec_actor_without_interview,
      empretecGraphics: empretec_graphics_withtou_interview,
      empretecCandidateTextImg: empretec_candidate_text_without_interview,
    };
  }, []);

  return (
    <LayoutCandidate pageSettings={pageSettings} moduleId={1}>
      <BackgroundCandidate
        empretecCandidateActor={pageSettings.empretecCandidateActor}
        empretecGraphics={pageSettings.empretecGraphics}
      >
        <CandidateInterviewWrapper>
          <ImageEmpretecText
            key={pageSettings.empretecCandidateTextImg}
            imgTextHome={pageSettings.empretecCandidateTextImg}
          />
          <ContentWithOutInterviewWrapper>
            <div>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae45}
              >
                {`Olá ${tokenInfo?.name?.trim()}, vimos que você não possui uma entrevista ` +
                  'de seleção para ser respondida no Empretec. '}
              </BaSeParagraph>
              <BaSeParagraph
                color={BaSeTheme.colors.institucionais.cinzaSebrae45}
              >
                {'Caso não tenha realizado o seminário e deseje conhecer mais, acesse ' +
                  'o Portal do Sebrae através do link.'}
              </BaSeParagraph>
            </div>

            <Button
              calback={() =>
                (window.location.href =
                  'https://sebrae.com.br/sites/PortalSebrae/empretec')
              }
              value={'ACESSE AQUI O PORTAL SEBRAE'}
              valueSmall={'ACESSE PORTAL SEBRAE'}
              color={'#25091A'}
              withBorder={true}
              borderColor="#B62A7E"
            />

            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Esperamos vê-lo em breve por aqui.
            </BaSeParagraph>
          </ContentWithOutInterviewWrapper>
        </CandidateInterviewWrapper>
      </BackgroundCandidate>
    </LayoutCandidate>
  );
};
